import { useSearchParams } from "react-router-dom";
import { assetAllocationPages } from "@app/const/route.const";
import { ModulePerformanceRiskReport } from "@app/pages/portfolioAnalysis/pdfPerformanceRiskReport/ModulePerformanceRiskReport";

export const PdfAssetAllocationModulePerformanceRiskReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, data1Id, data2Id, startYear, endYear } =
    assetAllocationPages.getPdfModulePerformanceRiskReportParams(searchParams);

  return (
    <ModulePerformanceRiskReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      footer="Asset Allocation"
      data1Id={data1Id}
      data2Id={data2Id}
      startYear={startYear}
      endYear={endYear}
    />
  );
};
